<!--
+------------------------------------------------------------------+
| Author: Jeffrey Thümann                                          |
| Component: PlaceOverview                                         |
| Section: views/overviews                                         |
| Purpose: Place overview with map-centric location exploration.   |
+------------------------------------------------------------------+
-->
<template>
    <div class="place-overview">
        <ImmersiveBackLink />
        <PlaceMap />
    </div>
</template>

<script>
import { applyGenericSeo, applyBreadcrumbSeo } from '@/utils/seoUtils';
import PlaceMap from '@/components/PlaceMap.vue';
import ImmersiveBackLink from '@/components/ImmersiveBackLink.vue';

export default {
    components: {
        PlaceMap,
        ImmersiveBackLink,
    },
    mounted() {
        const title = "Plaatsen | Sejarah Thümann";
        const description = "Ontdek historische en culturele locaties van de familie Thümann via deze interactieve kaart.";
        const image = "https://sejarah-thumann.online/img/sejarah_thumann1080x781.4fc54a6a.jpg"; // Standaard banner-afbeelding
        const url = window.location.href;

        applyGenericSeo({ title, description, image, url }, { includeTwitter: true });
        applyBreadcrumbSeo([{ name: 'Home', url: 'https://sejarah-thumann.online/' }, { name: 'Plaatsen', url: 'https://sejarah-thumann.online/plaatsen' }]);
    }
}
</script>

<style scoped></style>
